"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputComponent = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _prepareInputName = _interopRequireDefault(require("../_utils/prepareInputName"));

var _withNamedError = _interopRequireDefault(require("../withNamedError"));

var _Button = _interopRequireDefault(require("../Button"));

require("./input.sass");

var InputComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(InputComponent, _React$PureComponent);

  function InputComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InputComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InputComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "controlled", _this.props.hasOwnProperty('value'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      value: _this.controlled ? null : _this.props.value
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleRef", function (element) {
      return _this.element = element;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (e) {
      if (!_this.controlled) {
        _this.setState({
          value: e.target.value,
          changed: true
        });
      }

      _this.props.onChange && _this.props.onChange(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onFocus", function (e) {
      _this.setState({
        focus: true
      });

      _this.props.onFocus && _this.props.onFocus(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onBlur", function (e) {
      _this.setState({
        focus: false
      });

      _this.props.onBlur && _this.props.onBlur(e);
    });
    return _this;
  }

  (0, _createClass2.default)(InputComponent, [{
    key: "blur",
    value: function blur() {
      this.element && this.element.blur();
    }
  }, {
    key: "renderElement",
    value: function renderElement(props) {
      return _react.default.createElement("input", (0, _extends2.default)({}, props, {
        name: (0, _prepareInputName.default)(props.name),
        ref: this.handleRef,
        className: "input-field",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }));
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (this.state.changed) {
        return this.props.value || this.state.value;
      }

      return this.props.value || this.props.defaultValue;
    }
  }, {
    key: "isDirty",
    value: function isDirty() {
      var value = this.getValue();
      return !(value === null || value === undefined || value === '');
    }
  }, {
    key: "formatError",
    value: function formatError(error) {
      switch ((0, _typeof2.default)(error)) {
        case 'string':
          return error;

        case 'object':
          return error[Object.keys(error)[0]];

        default:
          return 'New error format ' + JSON.stringify(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          className = _this$props.className,
          error = _this$props.error,
          Icon = _this$props.Icon,
          hasFocus = _this$props.hasFocus,
          onIconClick = _this$props.onIconClick,
          secure = _this$props.secure,
          additional = _this$props.additional,
          onAdditionalClick = _this$props.onAdditionalClick,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["label", "className", "error", "Icon", "hasFocus", "onIconClick", "secure", "additional", "onAdditionalClick"]);
      var inputClassName = (0, _classnames.default)('input', {
        'input--label': label,
        'input--dirty': this.isDirty(),
        'input--focus': hasFocus || !props.readOnly && this.state.focus,
        'input--iconRight': !!Icon,
        'input--additional': !!additional,
        'input--secure': secure
      });

      var icon = Icon && _react.default.createElement(Icon, {
        className: (0, _classnames.default)('input-icon input-icon--right', {
          'input-icon--action': onIconClick
        }),
        onClick: onIconClick
      });

      var additionalAction = additional && _react.default.createElement(_Button.default, {
        label: additional,
        className: "input-additional",
        small: true,
        borderless: true,
        onClick: onAdditionalClick
      });

      return _react.default.createElement("label", {
        className: (0, _classnames.default)('form-field', className, {
          'form-field--error': error
        })
      }, _react.default.createElement("span", {
        className: inputClassName
      }, label && _react.default.createElement("span", {
        className: "form-field-label"
      }, label), this.renderElement(props), icon, additionalAction), error && _react.default.createElement("span", {
        className: "form-field-error"
      }, this.formatError(error)));
    }
  }]);
  return InputComponent;
}(_react.default.PureComponent);

exports.InputComponent = InputComponent;
(0, _defineProperty2.default)(InputComponent, "defaultProps", {
  type: 'text'
});
InputComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onIconClick: _propTypes.default.func,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.default.Component)]),
  readOnly: _propTypes.default.bool,
  name: _propTypes.default.string,
  error: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  label: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  placeholder: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  secure: _propTypes.default.bool
} : {};
var Input = (0, _withNamedError.default)(InputComponent);
var _default = Input;
exports.default = _default;